import FormSubmitBar, { FormSubmitBarProps } from './FormSubmitBar';

export default FormSubmitBar;

export type { FormSubmitBarProps };
